import { Box, Typography, Divider, Link } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import { defaultStyle } from "components/Modals";
import { ProtectedPaths } from "routes";

interface UnsyncedClient {
  id: number;
  name: string;
}

interface UnsyncedClientsModalProps {
  clients: UnsyncedClient[];
  loading: boolean;
  error: string | null;
  onClose: () => void;
}

const UnsyncedClientsModal = ({
  clients,
  loading,
  error,
  onClose,
}: UnsyncedClientsModalProps) => {
  const headerSuffix =
    !loading && !error ? ` (${clients.length})` : "";

  return (
    <Box sx={defaultStyle}>
      <Typography variant="h6" sx={{ mb: 1 }}>
        Unsynced clients{headerSuffix}
      </Typography>
      <Typography variant="body2" color="textSecondary" sx={{ mb: 2 }}>
        Clients that failed the last GO sync.
      </Typography>
      <Divider sx={{ mb: 2 }} />

      {loading ? (
        <Typography variant="body2" color="textSecondary">
          Loading...
        </Typography>
      ) : error ? (
        <Typography variant="body2" color="error">
          {error}
        </Typography>
      ) : clients.length === 0 ? (
        <Typography variant="body2" color="success.main">
          All clients synced successfully
        </Typography>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 0.5,
            maxHeight: 360,
            overflowY: "auto",
          }}
        >
          {clients.map((client) => (
            <Link
              key={client.id}
              component={RouterLink}
              to={`/${ProtectedPaths.Clients}/${client.id}`}
              onClick={onClose}
              underline="hover"
              sx={{ py: 0.5 }}
            >
              {client.name}
            </Link>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default UnsyncedClientsModal;
